import React from 'react';
import { FaShieldAlt, FaCheckCircle, FaLeaf } from 'react-icons/fa';
import './HomeTrust.css';

const HomeTrust = () => {
  return (
    <section className="home-trust">
      <div className="trust-inner">
        <h3 className="trust-title">Neden Bizi Seçmelisiniz?</h3>
        <div className="trust-grid">
          <div className="trust-item">
            <FaShieldAlt className="trust-icon" />
            <p className="trust-heading">Güvenli Hizmet</p>
            <small>Yetkili ve sigortalı teknik ekip</small>
          </div>
          <div className="trust-item">
            <FaCheckCircle className="trust-icon" />
            <p className="trust-heading">Garantili İşçilik</p>
            <small>İşçilik garantisi ile destek</small>
          </div>
          <div className="trust-item">
            <FaLeaf className="trust-icon" />
            <p className="trust-heading">Enerji Tasarrufu</p>
            <small>Verimli çözümler ile tasarruf</small>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeTrust;
